<div class="cancellation-card mt-5">
  <div class="flex items-center gap-2">
    <i class="ph ph-x-circle text-2xl"></i>
    <h5 class="font-bold">Pedido cancelado</h5>
  </div>

  <div class="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-2 gap-4 mt-4">
    @if (cancelledAt()) {
      <div>
        <p class="cancellation-label">Cancelado em</p>
        <p class="font-bold">{{ cancelledAt() | date: "dd/MM/yyyy HH:mm" }}</p>
      </div>
    }
    @if (cancelledBy()) {
      <div>
        <p class="cancellation-label">Cancelado por</p>
        <p class="font-bold">{{ cancelledBy() }}</p>
      </div>
    }
  </div>

  @if (cancellation()) {
    <div class="bg-white rounded-lg p-4 mt-4">
      <p class="font-bold">{{ reason() ?? "Motivo não informado" }}</p>
      @if (additionalDetails()) {
        <p class="mt-1">{{ additionalDetails() }}</p>
      } @else {
        <p class="mt-1 italic text-gray-500">Nenhuma justificativa informada.</p>
      }
    </div>
  }
</div>
